module.exports = __webpack_public_path__ + "static/media/toiletQuestion.8d1bf787.png";